export default {
  'read-more': 'Lire plus',
  login: 'se connecter',
  hello: 'hello {0}',
  firstpage: 'Ma première page',
  'en-gb': 'English',
  'fr-fr': 'Français',
  languages: 'Langages'
};
